import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { fetchData, postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';


const ItemCreate = (props) => {
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [name, setName] = useState("");
    const [gstRate, setGstRate] = useState("0");
    const [isSubmit, setisSubmit] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    const clearForm = () => {
        setName("");
        setGstRate("0");
    };

    //ProductCategory

    const [selectedProduct, setSelectedProduct] = useState("");
    const [productOptions, setProductOptions] = useState([]);
    const [selectedProductType, setSelectedProductType] = useState("");

    const fetchProductCategory = async () => {
        try {
            const response = await fetchData('ProductCategoryApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(product => ({
                    value: product.id,
                    label: product.name
                }));
                setProductOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleProductCategoryChange = (selectedOption) => {
        setSelectedProductType(selectedOption);
    };

    useEffect(() => {
        fetchProductCategory();
    }, []);




    const submitData = async (e) => {
        e.preventDefault();

        if (!name) {
            setErrorMessage("All fields are required!");
            setisSubmit(false);
            setIsLoading(true);
            return;
        }


        if (!selectedProductType) {
            setErrorMessage('ProductCategory is required ! Please fill all required fields.');
            setIsLoading(false);
            return;
        }

        const CreateData = {
            Name: name,
            GSTRate: gstRate,
            ProductCategoryId: selectedProductType.value,
            CreatedBy: userId,
            CompanyId: companyId,
            CreatedDate: new Date(),
        };

        postData('CategoryApi', CreateData, token)
            .then((response) => {
                console.log('Category Created success:', response);
                setSuccessMessage("Category Created successfully!");
                setErrorMessage("");
                clearForm();
                history.push('/ItemIndex');
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Item Create error:', error);
                setIsLoading(false);
            });
    };

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto">
                <form onSubmit={submitData}>
                    <div className='w-full mb-2 flex'>
                        <h6 className='uppercase productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>Variant</h6>

                        <Tooltip title="Exit">
                            <Link to="/ItemIndex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                                <Button style={{ color: 'red', fontWeight: 'bolder' }}>
                                    Exit <ExitToAppIcon />
                                </Button>
                            </Link>
                        </Tooltip>


                        <Tooltip title="SAVE">

                            <Button onClick={submitData} style={{ color: 'darkolivegreen', fontWeight: 'bolder', marginLeft: '2px' }} disabled={isLoading}>
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"} <CheckCircleIcon />
                            </Button>

                        </Tooltip>
                    </div>
                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}

                    <div className="w-full mb-4 flex">

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Category
                            </label>

                            <Select
                                value={selectedProductType}
                                onChange={handleProductCategoryChange}
                                options={productOptions}
                                placeholder="Category"
                                isSearchable
                            />
                        </div>
                        <div className="w-1/2 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Item Name
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                type="text"
                                placeholder="Enter Item Name"
                            />
                        </div>

                        <div className="w-1/8 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                GST Rate
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline text-right"
                                value={gstRate}
                                onChange={(e) => setGstRate(e.target.value)}
                                type="number"
                                placeholder="Enter GST Rate"
                            />
                        </div>
                    </div>

                </form>
            </div>
        </Fragment>
    );
}

export default ItemCreate;

